import LockupRating from './lockupRating'

export default LockupRating
